import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowEndcustomerService } from '../workflow-endcustomer.service';
import { WorkflowComponent } from '../../workflow.component';
import { firstValueFrom } from 'rxjs';
import { SaleOrder } from 'src/app/buy/buy.model';
import { tariffFlatNames } from 'src/app/tariff/tariff.model';

@Component({
    selector: 'app-workflow-endcustomer-one-tariff-order-cancel',
    templateUrl: './workflow-endcustomer-one-tariff-order-cancel.component.html',
    standalone: false
})
export class WorkflowEndcustomerOneTariffOrderCancelComponent extends WorkflowComponent implements OnInit {

    public subscription: Subscription;

    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowEndcustomerService: WorkflowEndcustomerService
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.setStep('order-cancel');
        this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
            next: (r) => {
                this.subscription = Subscription.fromJson(r);
                this.applianceId = this.subscription.appliance_id;
            },
            error: (err) => {
                console.error('Failed to load subscription:', err);
                this.router.navigate(['/subscriptions']);
                this.resetWorkflow();
            }
        });
    }

    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        try {
            const orderWithTariff = this.subscription?.orders?.find(order =>
                order?.lines?.some(line => tariffFlatNames.includes(line?.product))
            );

            if (orderWithTariff) {
                await firstValueFrom(this.workflowEndcustomerService.oneApplianceCancelTariffOrder(orderWithTariff.name));
            }

            this.resetWorkflow();
        } catch (e) {
            console.error('Cancel tariff order failed', e);
            this.resetWorkflow();
        }
    }
}
